export default __webpack_public_path__ + "static/media/home.7ef68a91.md";